"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, toFieldString, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
  isFirstComponent?: boolean;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};
export default function HorizontalBigImageNews(t0) {
  const $ = _c(87);
  const {
    title: t1,
    excerpt: t2,
    timeAgo: t3,
    imageSrc: t4,
    slug,
    priority: t5,
    imageMetadata,
    isFirstComponent: t6,
    templatetype: t7,
    isliveblog: t8
  } = t0;
  let t9;
  if ($[0] !== t1) {
    t9 = t1 === undefined ? {
      hidden: false,
      value: "'\u0B95\u0B9F\u0BBF\u0BA9 \u0B95\u0BA4\u0BCB\u0BB0\u0BBF \u0B85\u0BA3\u0BCD\u0B9F\u0B95\u0B9F\u0BB9\u0BAE\u0BCD' \u0BA4\u0BBF\u0BB0\u0BC8\u0BAA\u0BCD\u0BAA\u0B9F \u0BB5\u0BBF\u0BAE\u0BB0\u0BCD\u0B9A\u0BA9\u0BAE\u0BCD: \u0BB5\u0BC6\u0B95\u0BC1 \u0BA4\u0BCA\u0BA9\u0BB2\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD \u0B87\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B95\u0B9F\u0BA8\u0BCD\u0BA4 \u0B95\u0BBE\u0BB2\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BBF\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B89\u0BA3\u0BB0\u0BCD\u0B9A\u0BCD\u0B9A\u0BBF\u0BAF\u0BC8",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const title = t9;
  let t10;
  if ($[2] !== t2) {
    t10 = t2 === undefined ? {
      hidden: false,
      value: "\u0BA8\u0BBE\u0B9F\u0BCD\u0B9F\u0BBF\u0BA9\u0BCD \u0BA8\u0BBF\u0BB2\u0B95\u0BCD\u0B95\u0BB0\u0BBF \u0B89\u0BB1\u0BCD\u0BAA\u0BA4\u0BCD\u0BA4\u0BBF 2023 \u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BBF\u0BB2\u0BCD 8.5 \u0B9A\u0BA4\u0BB5\u0BC0\u0BA4\u0BAE\u0BCD \u0B85\u0BA4\u0BBF\u0B95\u0BB0\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1 7.314 \u0B95\u0BCB\u0B9F\u0BBF \u0B9F\u0BA9\u0BCD\u0BA9\u0BBE\u0B95",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const excerpt = t10;
  let excerptValue;
  let imageSrc;
  let imageSrcValue;
  let isliveblog;
  let priority;
  let t11;
  let templatetype;
  let timeAgo;
  let titleValue;
  if ($[4] !== excerpt?.value || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== t6 || $[9] !== t7 || $[10] !== t8 || $[11] !== title?.value) {
    timeAgo = t3 === undefined ? {
      hidden: false,
      value: "15 min ago",
      customClass: ""
    } : t3;
    let t12;
    if ($[21] !== excerpt?.value || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8 || $[27] !== title?.value) {
      imageSrc = t4 === undefined ? {
        hidden: false,
        value: FALLBACK_IMAGE,
        customClass: ""
      } : t4;
      priority = t5 === undefined ? false : t5;
      t6 === undefined ? false : t6;
      let t13;
      if ($[35] !== t7) {
        t13 = t7 === undefined ? {
          hidden: false,
          value: "",
          customClass: ""
        } : t7;
        $[35] = t7;
        $[36] = t13;
      } else {
        t13 = $[36];
      }
      templatetype = t13;
      let t14;
      if ($[37] !== t8) {
        t14 = t8 === undefined ? {
          hidden: false,
          value: "",
          customClass: ""
        } : t8;
        $[37] = t8;
        $[38] = t14;
      } else {
        t14 = $[38];
      }
      isliveblog = t14;
      const t15 = title?.value;
      let t16;
      if ($[39] !== t15) {
        t16 = toFieldString(t15);
        $[39] = t15;
        $[40] = t16;
      } else {
        t16 = $[40];
      }
      titleValue = t16;
      const t17 = excerpt?.value;
      let t18;
      if ($[41] !== t17) {
        t18 = toFieldString(t17);
        $[41] = t17;
        $[42] = t18;
      } else {
        t18 = $[42];
      }
      excerptValue = t18;
      t12 = getImageUrl(toFieldString(imageSrc?.value)) || FALLBACK_IMAGE;
      $[21] = excerpt?.value;
      $[22] = t4;
      $[23] = t5;
      $[24] = t6;
      $[25] = t7;
      $[26] = t8;
      $[27] = title?.value;
      $[28] = excerptValue;
      $[29] = imageSrc;
      $[30] = isliveblog;
      $[31] = priority;
      $[32] = t12;
      $[33] = templatetype;
      $[34] = titleValue;
    } else {
      excerptValue = $[28];
      imageSrc = $[29];
      isliveblog = $[30];
      priority = $[31];
      t12 = $[32];
      templatetype = $[33];
      titleValue = $[34];
    }
    imageSrcValue = t12;
    t11 = getTimeAgo(toFieldString(timeAgo?.value));
    $[4] = excerpt?.value;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = title?.value;
    $[12] = excerptValue;
    $[13] = imageSrc;
    $[14] = imageSrcValue;
    $[15] = isliveblog;
    $[16] = priority;
    $[17] = t11;
    $[18] = templatetype;
    $[19] = timeAgo;
    $[20] = titleValue;
  } else {
    excerptValue = $[12];
    imageSrc = $[13];
    imageSrcValue = $[14];
    isliveblog = $[15];
    priority = $[16];
    t11 = $[17];
    templatetype = $[18];
    timeAgo = $[19];
    titleValue = $[20];
  }
  const timeAgoValue = t11;
  let t12;
  if ($[43] !== isliveblog?.value || $[44] !== templatetype?.value) {
    t12 = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
    $[43] = isliveblog?.value;
    $[44] = templatetype?.value;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  const isLiveBlog = t12;
  let t13;
  if ($[46] !== imageMetadata || $[47] !== imageSrc?.customClass || $[48] !== imageSrc?.hidden || $[49] !== imageSrcValue || $[50] !== priority || $[51] !== titleValue) {
    t13 = !imageSrc?.hidden && <div className={`relative shrink-0 overflow-hidden w-full aspect-[16/9] md:aspect-auto md:w-5/12 lg:w-2/5 md:h-[230px] ${imageSrc?.customClass || ""}`}><Image src={imageSrcValue} alt={titleValue} fill={true} className="object-cover" style={getFocusPointStyle(imageMetadata)} sizes="(max-width: 768px) 100vw, 40vw" loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} priority={priority} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[46] = imageMetadata;
    $[47] = imageSrc?.customClass;
    $[48] = imageSrc?.hidden;
    $[49] = imageSrcValue;
    $[50] = priority;
    $[51] = titleValue;
    $[52] = t13;
  } else {
    t13 = $[52];
  }
  let t14;
  if ($[53] !== isLiveBlog || $[54] !== title?.customClass || $[55] !== title?.hidden || $[56] !== titleValue) {
    t14 = !title?.hidden && <h3 className={`text-24-tamil-700 md:text-14-tamil-700 text-012061 font-medium leading-[1.4] ${title?.customClass || ""}`}>{isLiveBlog && <LiveBlink />}{titleValue}</h3>;
    $[53] = isLiveBlog;
    $[54] = title?.customClass;
    $[55] = title?.hidden;
    $[56] = titleValue;
    $[57] = t14;
  } else {
    t14 = $[57];
  }
  let t15;
  if ($[58] !== excerpt?.customClass || $[59] !== excerpt?.hidden || $[60] !== excerptValue) {
    t15 = !excerpt?.hidden && <p className={`text-14-tamil-400 md:text-12-tamil-400 text-4D4D4D leading-[1.6] line-clamp-2 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[58] = excerpt?.customClass;
    $[59] = excerpt?.hidden;
    $[60] = excerptValue;
    $[61] = t15;
  } else {
    t15 = $[61];
  }
  let t16;
  if ($[62] !== t14 || $[63] !== t15) {
    t16 = <div className="flex flex-col gap-3">{t14}{t15}</div>;
    $[62] = t14;
    $[63] = t15;
    $[64] = t16;
  } else {
    t16 = $[64];
  }
  let t17;
  if ($[65] !== timeAgo?.customClass || $[66] !== timeAgo?.hidden || $[67] !== timeAgoValue) {
    t17 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-4D4D4D ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[65] = timeAgo?.customClass;
    $[66] = timeAgo?.hidden;
    $[67] = timeAgoValue;
    $[68] = t17;
  } else {
    t17 = $[68];
  }
  const t18 = slug ? `/${slug}` : undefined;
  let t19;
  if ($[69] !== excerptValue || $[70] !== imageSrcValue || $[71] !== slug || $[72] !== t18 || $[73] !== titleValue) {
    t19 = <MessageIcon id="image-news-desc-vert-message-icon" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t18} />;
    $[69] = excerptValue;
    $[70] = imageSrcValue;
    $[71] = slug;
    $[72] = t18;
    $[73] = titleValue;
    $[74] = t19;
  } else {
    t19 = $[74];
  }
  let t20;
  if ($[75] !== t17 || $[76] !== t19) {
    t20 = <div className="mt-3"><div className="flex items-center justify-between">{t17}{t19}</div></div>;
    $[75] = t17;
    $[76] = t19;
    $[77] = t20;
  } else {
    t20 = $[77];
  }
  let t21;
  if ($[78] !== t16 || $[79] !== t20) {
    t21 = <div className="flex flex-col justify-between w-full">{t16}{t20}</div>;
    $[78] = t16;
    $[79] = t20;
    $[80] = t21;
  } else {
    t21 = $[80];
  }
  let t22;
  if ($[81] !== t13 || $[82] !== t21) {
    t22 = <article className="p-4"><div className="flex flex-col md:flex-row gap-4">{t13}{t21}</div></article>;
    $[81] = t13;
    $[82] = t21;
    $[83] = t22;
  } else {
    t22 = $[83];
  }
  const content = t22;
  if (slug) {
    const t23 = `/${slug}`;
    let t24;
    if ($[84] !== content || $[85] !== t23) {
      t24 = <Link href={t23} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[84] = content;
      $[85] = t23;
      $[86] = t24;
    } else {
      t24 = $[86];
    }
    return t24;
  }
  return content;
}